import { createContext, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { activeQuotePageMounted } from "../redux/actions";
import Spinner from "../../common/components/Spinner/Spinner";
import ActiveQuoteEdit from "./ActiveQuoteEdit/ActiveQuoteEdit";
import { Mode } from "../../Cart/models/QuoteData";
import ActiveQuoteReview from "./ActiveQuoteReview/ActiveQuoteReview";
import { type RootState } from "../../redux/store";
import { useTranslation } from "react-i18next";
import { useOnMount } from "~/common/hooks/useOnMount";
import { LinkButton } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

import classes from "./ActiveQuoteRootPage.module.less";
import { PageTitle } from "~/common/components/PageTitle/v2/PageTitle";

type SetModeFunc = (mode: Mode) => void;
export const ActiveQuotePageModeContext = createContext<SetModeFunc>(() => {
  throw Error("Not supported");
});

const ActiveQuoteRootPage = () => {
  const { t } = useTranslation();
  const [pageMode, setPageMode] = useState<Mode>(Mode.EDIT);
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const accNo = useSelector(selectAccountNumber);

  useOnMount(() => {
    dispatch(activeQuotePageMounted());
  });

  if (loading) {
    return <Spinner />;
  }

  const context = !accNo ? "noAccNo" : undefined;

  const editButton = pageMode === Mode.REVIEW && (
    <LinkButton
      onClick={() => setPageMode(Mode.EDIT)}
      iconBefore={<Icon type={IconType.Pencil} />}
      className={classes.editButton}
    >
      {t("activeQuotePage.backToQuote")}
    </LinkButton>
  );

  return (
    <ActiveQuotePageModeContext.Provider value={setPageMode}>
      <div className={classes.titleContainer}>
        <PageTitle className={classes.title}>{t("activeQuotePage.title", { context, accNo })}</PageTitle>
        {editButton}
      </div>

      {pageMode === Mode.EDIT && <ActiveQuoteEdit />}
      {pageMode === Mode.REVIEW && <ActiveQuoteReview />}
    </ActiveQuotePageModeContext.Provider>
  );
};

export default ActiveQuoteRootPage;

const selectLoading = (state: RootState) => state.cartPage.loading;
const selectAccountNumber = (state: RootState) => state.cartPage.accountNumber;
